import type { FieldKind, SignParty } from "../types";

export const FIELD_KINDS: { id: FieldKind; label: string }[] = [
  { id: "text", label: "Texte" },
  { id: "paraphe", label: "Initiales" },
  { id: "date", label: "Date" },
  { id: "number", label: "Nombre" },
  { id: "check", label: "Coche" },
  { id: "radio", label: "Radio" },
  { id: "select", label: "Sélection" },
  { id: "stamp", label: "Tampon" },
  { id: "phone", label: "Téléphone" },
  { id: "signature", label: "Signature" },
];

export function partyColor(parties: SignParty[], partyId?: number | null): string {
  const hit = parties.find((p) => p.id === partyId);
  return hit?.color || parties[0]?.color || "#8d5bb8";
}

export function partyName(parties: SignParty[], partyId?: number | null): string {
  return parties.find((p) => p.id === partyId)?.name || parties[0]?.name || "1re partie";
}

export function fieldLabel(kind: FieldKind): string {
  return FIELD_KINDS.find((k) => k.id === kind)?.label ?? (kind === "name" ? "Nom" : kind);
}
